var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_971:923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27.0001 13.4241 26.6898 11.8636 26.0868 10.4076C25.4838 8.95168 24.5999 7.62875 23.4856 6.51443C22.3712 5.4001 21.0483 4.51619 19.5924 3.91318C18.1364 3.31017 16.5759 2.99987 15 3ZM18.8154 21.183C18.7705 21.295 18.7022 21.3961 18.615 21.4795C18.5278 21.5629 18.4238 21.6267 18.3099 21.6667C18.1961 21.7066 18.075 21.7218 17.9548 21.7111C17.8346 21.7004 17.7181 21.6642 17.613 21.6048L14.3554 19.0735L12.2646 21.0024C12.2161 21.0382 12.1594 21.0613 12.0996 21.0695C12.0398 21.0776 11.979 21.0706 11.9226 21.0491L12.3234 17.463L12.3363 17.4731L12.3445 17.4023C12.3445 17.4023 18.2065 12.0653 18.4453 11.8379C18.687 11.6111 18.6073 11.5619 18.6073 11.5619C18.621 11.2853 18.1734 11.5619 18.1734 11.5619L10.4064 16.5588L7.17182 15.4572C7.17182 15.4572 6.67502 15.279 6.62822 14.8872C6.57902 14.4984 7.188 14.2872 7.188 14.2872L20.0484 9.17819C20.0484 9.17819 21.1056 8.70716 21.1056 9.4872L18.8154 21.183Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_971:923",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_971:923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_971:923",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.55aa5b8cfe84f2c909e9cfdd259a1a8a.svg";
export { ForwardRef as ReactComponent };